import React from 'react'
import styles from './Footer.module.scss'
import { Row, Col, Container } from 'react-bootstrap'
import { BRAND_CONFIG } from '../../branding/brandConfig'
import { FaGithub } from 'react-icons/fa'

function SubstackLogo({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z" />
    </svg>
  )
}

export default function Footer() {
  const substackUrl = process.env.REACT_APP_SUBSTACK_URL

  return (
    <Container fluid style={{ backgroundColor: 'var(--dark)' }}>
      <Container className={styles.footer}>
        <Row>
          <Col xs={12} md={7}>
            <p className={styles.body}>{BRAND_CONFIG.footer.body}</p>
          </Col>
          <Col xs={12} md={5} className={styles.rightCol}>
            <br/>
            <a
              href="https://github.com/andjames"
              className={styles.socialButton}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub size={20} />
              andjames
            </a>
            {substackUrl && (
              <a
                href={substackUrl}
                className={styles.socialButton}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SubstackLogo size={20} />
                On Substack
              </a>
            )}
          </Col>
        </Row>
      </Container>
    </Container>
  )
}
